import { render, staticRenderFns } from "./voice-integrity-review-dialog.vue?vue&type=template&id=5ac845db&scoped=true"
import script from "./voice-integrity-review-dialog.vue?vue&type=script&lang=js"
export * from "./voice-integrity-review-dialog.vue?vue&type=script&lang=js"
import style0 from "./voice-integrity-review-dialog.vue?vue&type=style&index=0&id=5ac845db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac845db",
  null
  
)

export default component.exports